import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// component copied from react-otp-input v2.4.0 after problems with upgrading to v3 that broke how we use component
// component required upgrade as it had hardcoded peerDependency on react 16 that caused errors on installation
import React, { Component, PureComponent } from "react";
// Doesn't really check if it's a style Object
// Basic implementation to check if it's not a string
// of classNames and is an Object
const isStyleObject = (obj) => typeof obj === "object";
class SingleOtpInput extends PureComponent {
    input;
    constructor(props) {
        super(props);
        this.input = React.createRef();
    }
    // Focus on first render
    // Only when shouldAutoFocus is true
    componentDidMount() {
        const { focus, shouldAutoFocus } = this.props;
        const { current: inputEl } = this.input;
        if (inputEl && focus && shouldAutoFocus) {
            inputEl.focus();
        }
    }
    componentDidUpdate(prevProps) {
        const { focus } = this.props;
        const { current: inputEl } = this.input;
        // Check if focusedInput changed
        // Prevent calling function if input already in focus
        if (prevProps.focus !== focus && inputEl && focus) {
            inputEl.focus();
            inputEl.select();
        }
    }
    getClasses = (...classes) => classes.filter((c) => !!c && !isStyleObject(c)).join(" ");
    getType = () => {
        const { isInputSecure, isInputNum } = this.props;
        if (isInputSecure) {
            return "password";
        }
        if (isInputNum) {
            return "tel";
        }
        return "text";
    };
    render() {
        const { placeholder, separator, isLastChild, inputStyle, focus, isDisabled, hasErrored, errorStyle, focusStyle, disabledStyle, isInputNum, autocompleteType, index, value, className, onInput, onBlur, onFocus, onKeyDown, onPaste, onChange, "data-testid": dataTestId, } = this.props;
        return (_jsxs("div", { className: className, style: { display: "flex", alignItems: "center" }, children: [_jsx("input", { "aria-label": `${index === 0 ? "Please enter verification code. " : ""}${isInputNum ? "Digit" : "Character"} ${index + 1}`, autoComplete: autocompleteType, style: Object.assign({ width: "1em", textAlign: "center" }, isStyleObject(inputStyle) && inputStyle, focus && isStyleObject(focusStyle) && focusStyle, isDisabled && isStyleObject(disabledStyle) && disabledStyle, hasErrored && isStyleObject(errorStyle) && errorStyle), placeholder: placeholder, className: this.getClasses(inputStyle, focus && focusStyle, isDisabled && disabledStyle, hasErrored && errorStyle), type: this.getType(), ref: this.input, disabled: isDisabled, value: value ? value : "", onFocus: onFocus, onBlur: onBlur, onInput: onInput, onKeyDown: onKeyDown, onPaste: onPaste, onChange: onChange, "data-testid": dataTestId, inputMode: isInputNum ? "numeric" : "text" }), !isLastChild && separator] }));
    }
}
const defaultNumInputs = 4;
export class OtpInput extends Component {
    static defaultProps = {
        numInputs: defaultNumInputs,
        onChange: (otp) => console.log(otp),
        isDisabled: false,
        shouldAutoFocus: false,
        value: "",
        isInputSecure: false,
    };
    state = {
        activeInput: 0,
    };
    getOtpValue = () => (this.props.value ? this.props.value.toString().split("") : []);
    getPlaceholderValue = () => {
        const { placeholder, numInputs } = this.props;
        if (typeof placeholder === "string") {
            if (placeholder.length === numInputs) {
                return placeholder;
            }
            if (placeholder.length > 0) {
                console.error("Length of the placeholder should be equal to the number of inputs.");
            }
        }
    };
    // Helper to return OTP from input
    handleOtpChange = (otp) => {
        const { onChange } = this.props;
        const otpValue = otp.join("");
        onChange?.(otpValue);
    };
    isInputValueHasValidType = (value) => this.props.isInputNum ? !isNaN(parseInt(value, 10)) : typeof value === "string";
    isSingleInputValueValid = (value) => this.isInputValueHasValidType(value) && value.trim().length === 1;
    // Focus on input by index
    focusInput = (input) => {
        const { numInputs = defaultNumInputs } = this.props;
        const activeInput = Math.max(Math.min(numInputs - 1, input), 0);
        this.setState({ activeInput });
    };
    // Focus on next input
    focusNextInput = () => {
        const { activeInput } = this.state;
        this.focusInput(activeInput + 1);
    };
    // Focus on previous input
    focusPrevInput = () => {
        const { activeInput } = this.state;
        this.focusInput(activeInput - 1);
    };
    // Change OTP value at focused input
    changeCodeAtFocus = (value) => {
        const { activeInput } = this.state;
        const otp = this.getOtpValue();
        otp[activeInput] = value[0];
        this.handleOtpChange(otp);
    };
    breakAndPasteOtp = (otpCode) => {
        const otp = this.getOtpValue();
        const { numInputs = defaultNumInputs } = this.props;
        const { activeInput } = this.state;
        let nextActiveInput = activeInput;
        // Get pastedData in an array of max size (num of inputs - current position)
        const pastedData = otpCode.slice(0, numInputs - activeInput).split("");
        // Paste data from focused input onwards
        for (let pos = 0; pos < numInputs; ++pos) {
            if (pos >= activeInput && pastedData.length > 0) {
                otp[pos] = pastedData.shift() || "";
                nextActiveInput++;
            }
        }
        this.setState({ activeInput: nextActiveInput }, () => {
            this.focusInput(nextActiveInput);
            this.handleOtpChange(otp);
        });
    };
    // Handle pasted OTP
    handleOnPaste = (e) => {
        e.preventDefault();
        const { isDisabled } = this.props;
        if (isDisabled) {
            return;
        }
        // Get pastedData
        const pastedData = e.clipboardData.getData("text/plain");
        this.breakAndPasteOtp(pastedData);
    };
    handleOnChange = (e) => {
        const { value } = e.target;
        if (this.isSingleInputValueValid(value)) {
            this.changeCodeAtFocus(value);
        }
    };
    // Handle cases of backspace, delete, left arrow, right arrow, space
    handleOnKeyDown = (e) => {
        if (e.code === "Backspace" || e.key === "Backspace") {
            e.preventDefault();
            this.changeCodeAtFocus("");
            this.focusPrevInput();
        }
        else if (e.code === "Delete" || e.key === "Delete") {
            e.preventDefault();
            this.changeCodeAtFocus("");
        }
        else if (e.code === "ArrowLeft" || e.key === "ArrowLeft") {
            e.preventDefault();
            this.focusPrevInput();
        }
        else if (e.code === "ArrowRight" || e.key === "ArrowRight") {
            e.preventDefault();
            this.focusNextInput();
        }
        else if (e.key === " " || e.code === "Space") {
            e.preventDefault();
        }
    };
    // The content may not have changed, but some input took place hence change the focus
    handleOnInput = (e) => {
        const { numInputs = defaultNumInputs } = this.props;
        if (e.currentTarget.value.length === numInputs && this.isInputValueHasValidType(e.currentTarget.value)) {
            this.breakAndPasteOtp(e.currentTarget.value);
        }
        if (this.isSingleInputValueValid(e.currentTarget.value)) {
            this.focusNextInput();
        }
        else {
            // This is a workaround for dealing with keyCode "229 Unidentified" on Android.
            if (!this.props.isInputNum) {
                const { nativeEvent } = e;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error
                if (nativeEvent.data === null && nativeEvent.inputType === "deleteContentBackward") {
                    e.preventDefault();
                    this.changeCodeAtFocus("");
                    this.focusPrevInput();
                }
            }
        }
    };
    renderInputs = () => {
        const { activeInput } = this.state;
        const { numInputs = defaultNumInputs, inputStyle, focusStyle, separator, isDisabled = false, disabledStyle, hasErrored = false, errorStyle, shouldAutoFocus = false, isInputNum = false, isInputSecure = false, className, autocompleteType = "off", } = this.props;
        const inputs = [];
        const otp = this.getOtpValue();
        const placeholder = this.getPlaceholderValue();
        const dataCy = this.props["data-cy"];
        const dataTestId = this.props["data-testid"];
        const isRTL = document.dir === "rtl";
        for (let i = 0; i < numInputs; i++) {
            const isLastChild = isRTL ? i === 0 : i === numInputs - 1;
            inputs.push(_jsx(SingleOtpInput, { placeholder: placeholder?.[i], index: i, focus: activeInput === i, value: otp?.[i], onChange: this.handleOnChange, onKeyDown: this.handleOnKeyDown, onInput: this.handleOnInput, onPaste: this.handleOnPaste, onFocus: (e) => {
                    this.setState({ activeInput: i });
                    e.target.select();
                }, onBlur: () => this.setState({ activeInput: -1 }), separator: separator, inputStyle: inputStyle, focusStyle: focusStyle, isLastChild: isLastChild, isDisabled: isDisabled, disabledStyle: disabledStyle, hasErrored: hasErrored, errorStyle: errorStyle, shouldAutoFocus: shouldAutoFocus, isInputNum: isInputNum, isInputSecure: isInputSecure, className: className, "data-cy": dataCy && `${dataCy}-${i}`, "data-testid": dataTestId && `${dataTestId}-${i}`, autocompleteType: autocompleteType }, i));
        }
        return isRTL ? inputs.reverse() : inputs;
    };
    render() {
        const { containerStyle } = this.props;
        return (_jsx("div", { style: Object.assign({ display: "flex" }, isStyleObject(containerStyle) && containerStyle), className: !isStyleObject(containerStyle) ? containerStyle : "", "data-testid": "otpContainer", children: this.renderInputs() }));
    }
}
//# sourceMappingURL=OtpInput.js.map